// extracted by mini-css-extract-plugin
export default {"Container":"CustomPage_Container__9rJGp","BreadcrumbContainer":"CustomPage_BreadcrumbContainer__4+gb+","Content":"CustomPage_Content__3SUD0"};